import {useEffect, useState} from "react";
import {handleError} from "../utils2";


export function useGetJson(url, jwtToken = null, defaultValue = null, payload = null, method = 'GET', dependencies=[]) {
    const [value, setValue] = useState(defaultValue);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController()

        const bearer = jwtToken ? {Authorization: `Bearer ${jwtToken}`} : null

        const requestOptions = {
            method: method,
            headers: {"Accept": "application/json", "Content-Type": "application/json", ...bearer},
            signal: controller.signal,
            body: method === 'GET' || payload == null ? null : JSON.stringify(payload)
        }

        if (url) {
            setLoading(true)
            if (jwtToken !== undefined) {
                fetch(url, requestOptions)
                    .then(resp => resp.ok ? resp.text() : Promise.reject({error: `Response status: ${resp.status}`}))
                    .then(text => JSON.parse(text))
                    .then(json => json.success ? setValue(json) : Promise.reject({error: JSON.stringify(json.msg || json.message)}))
                    .catch(handleError)
                    .catch(setError)
                    .finally(() => setLoading(false))
            }
        } else {
            //setError("URL unprovided")
        }

        return () => {
            controller.abort()
            setLoading(false)
        }
    }, [url, jwtToken, ...dependencies])

    const clearError = () => setError(null)

    return [value, loading, error, clearError, setValue, setLoading]
}


export function useGetJsonDirect(url, jwtToken = null, defaultValue = null, payload = null, method = 'GET', dependencies=[]) {
    const [value, setValue] = useState(defaultValue);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController()

        const bearer = jwtToken ? {Authorization: `Bearer ${jwtToken}`} : null

        const requestOptions = {
            method: method,
            headers: {"Accept": "application/json", "Content-Type": "application/json", ...bearer},
            signal: controller.signal,
            body: method === 'GET' || payload == null ? null : JSON.stringify(payload)
        }

        if (url) {
            setLoading(true)
            if (jwtToken !== undefined) {
                fetch(url, requestOptions)
                    .then(resp => resp.ok ? resp.text() : Promise.reject({error: `Response status: ${resp.status}`}))
                    .then(text => JSON.parse(text))
                    .then(json => setValue(json.data))
                    .catch(handleError)
                    .catch(setError)
                    .finally(() => setLoading(false))
            }
        } else {
            //setError("URL unprovided")
        }

        return () => {
            controller.abort()
            setLoading(false)
        }
    }, [url, jwtToken, ...dependencies])

    const clearError = () => setError(null)

    return {value, loading, error, clearError, setValue, setLoading}
}

